module.exports = __webpack_public_path__ + "img/generation_purple.f5ff8f10.png";